module.exports = __webpack_public_path__ + "static/media/figma.b8a7a56c.svg";